export default __webpack_public_path__ + "static/media/refresh.f4c882bd.svg";